import type { AuthenticatedUser } from '../store/auth-store';
import { buildUpgradeCheckoutPath } from './checkout-intent';

export const BILLING_BLOCKED_STATUSES = new Set([
  'paused',
  'past_due',
  'incomplete',
  'incomplete_expired',
  'unpaid',
  'canceled',
  'cancelled',
]);

export const isDeferredSignupCheckoutIntent = (user?: AuthenticatedUser | null): boolean =>
  Boolean(
    user?.setupState === 'payment_pending' &&
    user.pendingCheckoutIntent?.source === 'signup' &&
    user.pendingCheckoutIntent?.intentOnly === true
  );

export const getPaymentPendingRedirect = (user?: AuthenticatedUser | null): string | null => {
  if (BILLING_BLOCKED_STATUSES.has(String(user?.subscriptionStatus ?? '').toLowerCase())) {
    return '/billing/pending-setup';
  }

  if (user?.setupState !== 'payment_pending') {
    return null;
  }

  if (isDeferredSignupCheckoutIntent(user) && user.pendingCheckoutIntent) {
    return buildUpgradeCheckoutPath(
      user.pendingCheckoutIntent.tier,
      user.pendingCheckoutIntent.billingCycle,
      user.pendingCheckoutIntent.source,
      user.pendingCheckoutIntent.trial === true
    );
  }

  return '/billing/pending-setup';
};
